<template>
  <div class="bgimage">
    <div id="canvas">
      <loading v-if="showLoad"></loading>
      <a @click.prevent="backPath">
        <img
          src='../assets/image/logoWhiteBottom.png'
          class="top-logo"
          alt="logo"
        >
      </a>
      <div class="flex-display">
        <div class="descriptionbox">
          <h1 class="descriptionbox__title no-line-break-div">{{ $t('title') }}</h1>
          <v-tooltip
            right
            color="white"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                draggable
                x-small
                v-bind="attrs"
                v-on="on"
                class="ml-2"
                color="blue-grey lighten-2"
              >
                v{{ version }}
              </v-chip>
            </template>
            <span>UI v{{ frontVersion }}</span>
          </v-tooltip>
          <h2 class="descriptionbox__detail">{{ $t('systemDescription') }}</h2>
          <h2 class="descriptionbox__detail">{{ $t('detail') }}</h2>
          <v-btn
            depressed
            class="mb-1"
            dark
            min-height="32"
            max-height="50"
            :small="$vuetify.breakpoint.lgAndDown"
            :x-large="$vuetify.breakpoint.xlOnly"
            color="red lighten-1"
            :href="oldSystemLink"
          >{{ $t('goToOldSystem') }}</v-btn>
          <div class="descriptionbox__select no-line-break-div ml-4">
            <v-select
              :items="langList"
              item-text="text"
              :value="langList.value"
              color="mainColor"
              item-color="mainColor"
              solo
              :dense="$vuetify.breakpoint.lgAndDown"
              prepend-inner-icon="mdi-earth"
              v-model="$i18n.locale"
              v-on:change="setLang(langList.value)"
            ></v-select>
          </div>
        </div>
        <div class="loginbox">
          <h1 class="loginbox__title">{{ $t('userLogin') }}</h1>
          <v-text-field
            :label="$t('account')"
            v-model="form.userID"
            @keyup.enter="submit"
            autofocus
            outlined
            rounded
            :dense="$vuetify.breakpoint.lgAndDown"
            color="#1f4e79"
            class="loginbox__inputstyle"
          ></v-text-field>
          <v-text-field
            :label="$t('password')"
            :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPwd ? 'text' : 'password'"
            @click:append="showPwd = !showPwd"
            @keyup.enter="submit"
            outlined
            rounded
            v-model="form.userPassword"
            :dense="$vuetify.breakpoint.lgAndDown"
            color="#1f4e79"
            class="loginbox__inputstyle"
          ></v-text-field>
          <div class="loginbox__btnbox">
            <v-btn
              class="loginbox__btnbox__btn"
              dark
              depressed
              @click="submit"
              color="mainColor"
              :large="$vuetify.breakpoint.xlOnly"
              :small="$vuetify.breakpoint.lgAndDown"
            >{{ $t('login') }}</v-btn>
            <a
              class="loginbox__btnbox__link"
              @click.prevent="registerPath"
            >
              {{$t('machineToolClientRegister')}}
            </a>
            <a
              class="loginbox__btnbox__link"
              @click.prevent="editPath"
            >
              {{$t('changePassword')}}
            </a>
            <a
              class="loginbox__btnbox__link"
              @click.prevent="forgetPath"
            >
              {{$t('forgetPassword')}}
            </a>
            <a
              v-if="remail.userID"
              class="loginbox__btnbox__link"
              @click="remailConfirm"
            >
              {{$t('remail')}}
            </a>
          </div>
          <div class="loginbox__verticalline"></div>
          <div class="no-line-break-div">
            <img
              src='../assets/image/loginQrcode.png'
              class="loginbox__image"
              alt="QRcode"
            >
          </div>
        </div>
      </div>
      <div class="px-5 cookie-alert">
        <cookieAlert></cookieAlert>
      </div>
      <errorDialog
        v-model="showRemailDialog"
        :dialogAlert="this.errorTitle"
        :dialogAlertDetail="this.errorDetail"
        v-on:error-child-method="remailConfirm"
        :showCancelBtn="true"
      ></errorDialog>
      <errorDialog
        v-model="showErrorDialog"
        :dialogAlert="this.errorTitle"
        :dialogAlertDetail="this.errorDetail"
      ></errorDialog>
      <successDialog
        v-model="showSuccessDialog"
        dialogColor="success"
        :showText="true"
        :dialogWidth="300"
        successIcon="mdi-check-circle"
        :successAlert="this.successTitle"
        :actionBtn="$t('confirm')"
      ></successDialog>
    </div>
  </div>
</template>

<script>
import loading from '@/components/loadingDisplay.vue';
import errorDialog from '@/components/errorDialog.vue';
import cookieAlert from '@/components/cookieAlert.vue';
import successDialog from '@/components/successDialog.vue';
import { mapMutations, mapGetters } from 'vuex';
import newOptionApiFunction from '../scriptFiles/api/backendApiFunction';
import errorCode from '../configFiles/errorCode.json';
import global from '../scriptFiles/globalParam';

export default {
  components: {
    loading,
    errorDialog,
    successDialog,
    cookieAlert,
  },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    frontVersion: process.env.VUE_APP_FRONTVERSION,
    showPwd: false,
    showLoad: false,
    showErrorDialog: false,
    showSuccessDialog: false,
    showRemailDialog: false,
    form: {
      userID: '',
      userPassword: '',
    },
    remail: {
      userID: '',
    },
    accessToken: '',
    errorTitle: '',
    errorDetail: '',
    successTitle: '',
    userName: '',
    weChatCode: '',
    openID: '',
    oldSystemLink: global.oldSystemLink,
  }),
  created() {
    const lang = this.$i18n.locale;
    const current = this.getReturnPage;
    if (localStorage.permissions !== undefined && current !== undefined) {
      this.$router.push({ path: `/${lang}/${current}` }).catch(() => {});
    }
    if (this.$route.query.verifyResult === 'True') {
      this.showSuccessDialog = true;
      this.successTitle = this.$t('registerSuccess');
      this.$router.push({ path: `/${lang}/` }).catch(() => {});
    }
    if (this.$route.query.verifyResult === 'False') {
      this.remail.userID = this.$route.query.userID;
      this.showRemailDialog = true;
      this.errorTitle = this.$t('verifyFail');
      this.errorDetail = this.$t('linkHasExpired');
      this.$router.push({ path: `/${lang}/` }).catch(() => {});
    }
    if (this.$route.query.code !== undefined) {
      const weChetQueryCode = this.$route.query.code;
      // 微信特規，微信發送連結所產生的queryString會自動帶入'&state='，導致本系統載入錯誤，因此移除此字串
      weChetQueryCode.replace('&state=', '');
      this.setWeChatLogin(true);
      this.showLoad = true;
      this.weChatCode = weChetQueryCode;
      newOptionApiFunction.wechatLoginApi({
        weChatCode: this.weChatCode,
      })
        .then(async (res) => {
          switch (res.data.code) {
            case errorCode.Success: {
              await this.getUserAccount();
              await this.getUserNameAction();
              await this.getUserCompanyName();
              await this.getUserRightAction();
              break;
            }
            case errorCode.Wechat_First_Login: {
              this.openID = res.data.content.openID;
              break;
            }
            case errorCode.Wechat_GetOpenID_Error: {
              this.errorTitle = this.$t('weChatLoginFail');
              this.errorDetail = this.$t('weChatGetOpenIDError');
              this.showErrorDialog = true;
              this.$router.push({ path: `/${lang}` });
              break;
            }
            default: {
              this.errorTitle = this.$t('weChatLoginFail');
              this.errorDetail = res.data.message;
              this.showErrorDialog = true;
              console.log(res.data);
              this.$router.push({ path: `/${lang}` });
            }
          }
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          this.showLoad = false;
        });
    } else {
      this.$gtag.set('user_properties', {
        user_name: 'No Login',
        user_company: 'No Login',
      });
    }
  },
  methods: {
    ...mapMutations(['setPermissions', 'setUserName', 'setUserID', 'setWeChatLogin']),
    setLang(value) {
      this.$i18n.setLocaleMessage(value);
      const lang = this.$i18n.locale;
      this.$router.push({ path: `/${lang}` });
    },
    forgetPath() {
      const lang = this.$i18n.locale;
      this.$router.push({ path: `/${lang}/forgetPassword` });
    },
    editPath() {
      const lang = this.$i18n.locale;
      this.$router.push({ path: `/${lang}/editPassword` });
    },
    registerPath() {
      const lang = this.$i18n.locale;
      this.$router.push({ path: `/${lang}/register` });
    },
    submit() {
      if (this.form.userID === '' || this.form.userID === undefined) {
        this.errorTitle = this.$t('loginfail');
        this.errorDetail = this.$t('accountRequired');
        this.showErrorDialog = true;
        return;
      }
      if (this.form.userPassword === '' || this.form.userPassword === undefined) {
        this.errorTitle = this.$t('loginfail');
        this.errorDetail = this.$t('pwdRequired');
        this.showErrorDialog = true;
        return;
      }
      this.showLoad = true;
      newOptionApiFunction.loginApi(this.form)
        .then(async (res) => {
          switch (res.data.code) {
            case errorCode.Success: {
              this.getUserAccount();
              if (this.$route.query.code !== undefined) {
                const wechatBindLogin = {
                  weChatOpenID: this.openID,
                  userID: this.form.userID,
                  userPassword: this.form.userPassword,
                };
                newOptionApiFunction.wechatBindLoginApi(wechatBindLogin)
                  .catch((err) => {
                    console.log(err);
                  });
              }
              this.setUserID(this.form.userID);
              await this.getUserNameAction();
              await this.getUserCompanyName();
              await this.getUserRightAction();
              break;
            }
            case errorCode.Auth_Error: {
              this.errorTitle = this.$t('loginfail');
              this.errorDetail = this.$t('contactManager');
              this.showErrorDialog = true;
              break;
            }
            case errorCode.Mail_Verify_Fail: {
              this.errorTitle = this.$t('loginfail');
              this.errorDetail = this.$t('Mail_Verify_Fail');
              this.remail.userID = this.form.userID;
              this.showRemailDialog = true;
              break;
            }
            case errorCode.UserID_UnExist: {
              this.errorTitle = this.$t('loginfail');
              this.errorDetail = this.$t('notRigister');
              this.showErrorDialog = true;
              break;
            }
            default:
              this.errorTitle = this.$t('loginfail');
              this.errorDetail = this.$t(res.data.message);
              this.showErrorDialog = true;
              console.log(res.data);
          }
        }).finally(() => {
          this.form = {};
          this.showLoad = false;
        });
    },
    backPath() {
      const lang = this.$i18n.locale;
      this.$router.push({ path: `/${lang}` }).catch(() => {});
    },
    remailConfirm() {
      this.remailVerifyMailApi(this.remail);
      this.showRemailDialog = false;
    },
    getUserNameAction() {
      return [
        newOptionApiFunction.getUserNameApi()
          .then((response) => {
            this.setUserName(response.data.content.userName);
          }).catch((error) => {
            console.log(error);
          }),
      ];
    },
    getUserCompanyName() {
      return [
        newOptionApiFunction.getCompanyName()
          .then((res) => {
            switch (res.data.code) {
              case errorCode.Success: {
                this.$gtag.set('user_properties', { user_company: res.data.content.companyName });
                break;
              }
              case errorCode.Select_Problem_No_Data: {
                this.$gtag.set('user_properties', { user_company: 'No Company Name' });
                break;
              }
              default: {
                console.log(res.data);
              }
            }
          }).finally(() => {
            this.showLoad = false;
          }),
      ];
    },
    getUserRightAction() {
      const lang = this.$i18n.locale;
      newOptionApiFunction.getUserRightApi()
        .then((response) => {
          const current = this.getReturnPage;
          this.setPermissions(response.data.content.rights);
          if (current !== undefined && current !== null) {
            this.$router.push({ path: `/${lang}/${current}` }).catch(() => {});
          } else {
            this.$router.push({ path: `/${lang}/mainPage` }).catch(() => {});
          }
        }).catch((error) => {
          console.log(error);
        });
    },
    getUserAccount() {
      return [
        newOptionApiFunction.getUserAccount()
          .then(async (res) => {
            switch (res.data.code) {
              case errorCode.Success: {
                this.setUserID(res.data.content.account);
                this.$gtag.set('user_properties', { user_name: res.data.content.account });
                break;
              }
              default: {
                console.log(res.data);
              }
            }
          }),
      ];
    },
    remailVerifyMailApi(data) {
      this.showLoad = true;
      newOptionApiFunction.remailVerifyMail(data)
        .then((res) => {
          switch (res.data.code) {
            case errorCode.Success: {
              this.successTitle = this.$t('submitSuccess');
              this.showSuccessDialog = true;
              break;
            }
            default: {
              this.errorTitle = this.$t('submitFail');
              this.errorDetail = this.$t(res.data.message);
              this.showErrorDialog = true;
              console.log(res.data);
            }
          }
        }).finally(() => {
          this.showLoad = false;
        });
    },
  },
  computed: {
    ...mapGetters(['getReturnPage']),
    langList() {
      return this.$i18n.availableLocales.map((lanCode) => ({
        text: this.$t(`${lanCode}`),
        value: lanCode,
      }));
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/scss/variables.scss';
  @import '@/scss/layouts/l-base.scss';
  @import '@/scss/modules/m-image.scss';
  @import '@/scss/modules/m-position.scss';
  @import '@/scss/modules/m-dialog.scss';
  .bgimage {
    width: 100%;
    height: 100%;
    margin: 0px auto;
    background: url('../assets/image/loginBackground.jpg') center center fixed
      no-repeat;
    background-size: cover;
    background-color: black;
  }
  .descriptionbox {
    padding-left: 9%;
    padding-top: 10%;
    width: 100%;
    margin-bottom: 30px;
  }
  .descriptionbox__title {
    margin-top: -5px;
    font-size: 36px;
    color: $fontColor;
  }
  .descriptionbox__detail {
    font-size: 20px;
    color: $fontColor;
    font-weight: lighter;
  }
  .descriptionbox__select {
    margin-top: 15px;
    width: 160px;
  }
  .loginbox {
    margin: 0px auto;
    background-color: rgba(255, 255, 255, 0.842);
    border-radius: 5px;
    padding: 20px 30px 20px;
    width: 85%;
  }
  .loginbox__title {
    font-weight: bolder;
    text-align: center;
    margin-bottom: 15px;
    font-size: 25px;
    color: $titleFontColor;
  }
  .loginbox__inputstyle {
    width: 100%;
    height: 55px;
  }
  .loginbox__btnbox {
    display: inline-block;
    align-items: center;
    width: 52%;
  }
  .loginbox__btnbox__btn {
    display: inline-block;
    margin: 15px 10px 10px 6px;
    color: white;
    width: 95%;
  }
  .loginbox__btnbox__link {
    display: block;
    font-size: 15px;
    margin-left: 8px;
    margin-bottom: 2px;
    color: $mainColor;
    text-decoration: none;
  }
  .loginbox__btnbox__link:hover {
    color: #3883ce;
    text-decoration: underline;
  }
  .loginbox__verticalline {
    display: inline-block;
    border-left: 2px solid rgb(145, 144, 144);
    height: 110px;
    padding-top: 50px;
    margin: 0px 10px 0px 18px;
  }
  .loginbox__image {
    width: 100px;
    margin: 0 0 9px 8px;
  }
  .cookie-alert {
    position: absolute;
    right: 0px;
    bottom: 0px;
    width: 100%;
  }
  @media screen and (min-width: 600px) {
    .descriptionbox {
      padding-left: 12%;
      margin-bottom: 30px;
    }
    .loginbox {
      margin-top: 100px;
      margin-bottom: 30px;
      width: 50%;
    }
  }
  @media screen and (min-width: 1264px) {
    .descriptionbox {
      width: 50%;
    }
    .loginbox {
      margin-top: 100px;
      margin-bottom: 30px;
      width: 28%;
    }
    .cookie-alert {
      position: fixed;
      left: 0px;
      bottom: 0px;
      width: 48%;
    }
  }
  @media screen and (min-width: 1904px) {
    .descriptionbox__title {
      font-size: 50px;
    }
    .descriptionbox__detail {
      font-size: 30px;
    }
    .loginbox {
      width: 28%;
      padding: 30px 50px;
      margin-top: 160px;
    }
    .loginbox__title {
      font-size: 30px;
    }
    .loginbox__btnbox {
      width: 45%;
      margin-left: 10px;
      margin-bottom: 5px;
    }
    .loginbox__inputstyle {
      height: 80px;
    }
    .loginbox__btnbox__link {
      font-size: 18px;
    }
    .loginbox__verticalline {
      height: 140px;
      margin: 8px 30px 0px 20px;
    }
    .loginbox__image {
      width: 130px;
      margin: 0 0 9px 8px;
    }
  }
</style>
